import * as React from "react";
const SvgFiRrPhoneCross = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-phone-cross_svg__a)">
      <path
        fill="#062147"
        d="m23 16.653-2.34-1.8a3.1 3.1 0 0 0-4.28.006l-1.47 1.168a12.78 12.78 0 0 1-6.93-6.945l1.157-1.456a3.1 3.1 0 0 0 .007-4.282L7.346 1A1 1 0 0 0 7.26.9 3.08 3.08 0 0 0 2.934.859l-1.15 1c-7.719 8.21 12.2 28.145 20.4 20.3l.91-1.05a3.1 3.1 0 0 0 0-4.377 1 1 0 0 0-.094-.08m-1.364 3.1-.91 1.05C14.787 26.418-2.5 10.113 3.146 3.325l1.15-1a1.1 1.1 0 0 1 1.51-.04L7.593 4.61a1 1 0 0 0 .086.1 1.1 1.1 0 0 1 0 1.549 1 1 0 0 0-.079.082L6.044 8.3a1 1 0 0 0-.145 1 15 15 0 0 0 8.822 8.81 1 1 0 0 0 .98-.151l1.96-1.56q.044-.034.083-.075a1.13 1.13 0 0 1 1.647.086l2.326 1.787a1.12 1.12 0 0 1-.085 1.557zm2.071-13.46a1 1 0 0 1-1.414 1.414L20 5.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L18.586 4l-2.293-2.293A1 1 0 0 1 17.707.293L20 2.586 22.293.293a1 1 0 0 1 1.414 1.414L21.414 4z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-phone-cross_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPhoneCross;
